// Share a request that is already on its way.
//
// React StrictMode invokes the effects that drive quote and issuance calls
// twice, and a remount does the same in production. For motor that meant two
// quotations minted at the carrier for one case; for pet it means two requests
// to an endpoint that is currently answering 500, and two error dialogs for one
// press.
//
// Concurrent callers share the one request. The entry is dropped once it
// settles, so a genuine retry still goes through.
/** @type {Map<string, Promise<*>>} */
const pending = new Map();

/**
 * @template T
 * @param {string} key       identifies the request — usually the case id
 * @param {() => Promise<T>} start
 * @returns {Promise<T>}
 */
export const shareInFlight = (key, start) => {
  const existing = pending.get(key);
  if (existing) return existing;

  const request = start().finally(() => pending.delete(key));
  pending.set(key, request);
  return request;
};

export default shareInFlight;
